var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundForeheadSmallScreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 723,
    viewBox: "0 0 390 723",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M390 723L-2.3973e-05 723L-2.85823e-06 65.3885L195 -3.72526e-05L390 65.3886L390 723Z",
    fill: "url(#paint0_linear_1242_78787)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1242_78787",
    x1: -0.00000111693,
    y1: 65.3884,
    x2: 367.075,
    y2: 34.8003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121419"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundForeheadSmallScreen);
export default __webpack_public_path__ + "static/media/BackgroundForeheadSmallScreen.57e27a5fe46ad12dbfeb2d8779b03e14.svg";
export { ForwardRef as ReactComponent };